import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Path } from "../constants/paths";

interface NavigationOptions {
  scrollToKarmaSection?: boolean;
  // Extra query params to merge into the current URL search when navigating
  extraQuery?: Record<string, string | undefined>;
}

const useAppNavigation = () => {
  const history = useHistory();

  const navigateToBuildKarma = useCallback(
    (options?: NavigationOptions) => {
      // Preserve existing query params (e.g., invite, utm) when navigating to build_karma
      const currentSearch =
        typeof window !== "undefined" ? window.location.search : "";

      const params = new URLSearchParams(currentSearch);

      if (options?.extraQuery) {
        Object.entries(options.extraQuery).forEach(([key, value]) => {
          if (value !== undefined && value !== null && `${value}`.length > 0) {
            params.set(key, `${value}`);
          }
        });
      }

      const search = params.toString();
      const href = `${Path.BUILD_KARMA}${search ? `?${search}` : ""}`;
      history.push(href, options);
    },
    [history]
  );

  const navigareToMainPage = (options?: NavigationOptions) => {
    history.push(Path.APP_MAIN, options);
  };

  const navigateToLink = (url: string) => {
    return () => window.open(url, "_blank", "noopener,noreferrer");
  };

  const navigateToDashboard = useCallback(
    (options?: any) => {
      history.push(Path.DASHBOARD, options);
    },
    [history]
  );

  const refreshPage = useCallback(() => {
    window.location.reload();
  }, []);

  return {
    navigateToBuildKarma,
    navigateToDashboard,
    navigareToMainPage,
    navigateToLink,
    refreshPage,
  };
};

export default useAppNavigation;
